"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getError = exports.getIsFetching = void 0;

var getIsFetching = function getIsFetching(state) {
  return state.apiFlow.customTableViews.save.isFetching;
};

exports.getIsFetching = getIsFetching;

var getError = function getError(state) {
  return state.apiFlow.customTableViews.save.error;
};

exports.getError = getError;